import React from 'react';

function ResultPage({ feedback, isLoading, onRestart, onHome, darkMode }) {
  const cardClass = darkMode 
    ? 'bg-gray-800 text-white' 
    : 'bg-white text-gray-800';

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
        <div className={`p-8 rounded-2xl ${cardClass} shadow-2xl text-center`}>
          <div className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-lg font-semibold">분석 중입니다...</p>
        </div>
      </div>
    );
  }

  if (!feedback) {
    return (
      <div className={`p-8 rounded-2xl ${cardClass} shadow-2xl text-center`}>
        <p>피드백을 생성하는 중입니다...</p>
      </div>
    );
  }

  return (
    <div className={`max-w-4xl w-full p-6 md:p-8 rounded-2xl shadow-2xl space-y-6 transition-all duration-500 ${cardClass}`}>
      
      {/* 완료 메시지 */}
      <div className="text-center mb-8">
        <div className="text-6xl mb-4 animate-bounce">🎉</div>
        <div className="text-2xl md:text-3xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          면접 연습 완료!
        </div>
        <div className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          수고하셨어요! 오늘도 한 걸음 성장했네요 😊
        </div>
      </div>

      {/* 면접관 총평 (메인 콘텐츠) */}
      <div className={`p-6 rounded-xl border-l-4 border-yellow-500 ${darkMode ? 'bg-yellow-900 bg-opacity-30' : 'bg-gradient-to-br from-yellow-50 to-orange-50'}`}>
        <h3 className={`text-lg font-bold mb-3 flex items-center ${darkMode ? 'text-yellow-300' : 'text-yellow-800'}`}>
          <span className="text-2xl mr-2">😸</span>
          면접 연습 총평
        </h3>
        <p className={`leading-relaxed whitespace-pre-line ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
          {feedback.summary}
        </p>
      </div>

      {/* 🆕 블로그 추천 섹션 */}
      <div className={`p-6 rounded-xl border ${darkMode ? 'bg-gradient-to-br from-blue-900 to-indigo-900 border-blue-700' : 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200'}`}>
        <div className="text-center mb-4">
          <div className="text-4xl mb-2">📚</div>
          <h3 className={`text-xl font-bold mb-2 ${darkMode ? 'text-blue-300' : 'text-blue-800'}`}>
            더 많은 면접 팁이 필요하다면?
          </h3>
          <p className={`text-sm ${darkMode ? 'text-blue-200' : 'text-blue-600'} mb-4`}>
            실제 기출문제와 합격 노하우를 확인해보세요!
          </p>
        </div>
        
        {/* 면접 준비 콘텐츠 미리보기 */}
        <div className="grid md:grid-cols-2 gap-4 mb-4">
          </div>
        
        {/* 이동 버튼들 */}
        <div className="text-center space-y-3 md:space-y-0 md:space-x-4 md:flex md:justify-center">
          <a 
            href="https://jobangel.tistory.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={`inline-flex items-center px-5 py-2.5 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl
              ${darkMode 
                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white' 
                : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white'
              }`}
          >
            <span className="text-base mr-2">📚</span>
            취업천사 블로그
          </a>
          
          <a 
            href="/guide-success" 
            className={`inline-flex items-center px-5 py-2.5 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl
              ${darkMode 
                ? 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white' 
                : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white'
              }`}
          >
            <span className="text-base mr-2">🎯</span>
            면접성공가이드
          </a>
        </div>
      </div>

      {/* 버튼들 */}
      <div className="text-center space-y-4 md:space-y-0 md:space-x-4 md:flex md:justify-center">
        <button 
          onClick={onHome} 
          className="w-full md:w-auto px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
        >
          🏠 홈으로 돌아가기
        </button>
        <button 
          onClick={onRestart} 
          className="w-full md:w-auto px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
        >
          🔄 같은 모드로 다시 연습
        </button>
      </div>
    </div>
  );
}

export default ResultPage;